module.exports = "/static/assets/47da7e3f44ded85df850a542a90eafa3.png";